module dg.lists {

    export interface IListOptions extends dg.actions.ICompositeDisplayerOptions {
        selectionType?: "single" | "multiple";
    }

    export interface IListPagingOptions {
        pageNumber?: number;
        pageSize?: number;
        pageFirstItem?: number;
        pageLastItem?: number;
        totalCount?: number;
        pageStep?: number;
    }

    export class ListOptionsService {

        public static getGridOptions(options?: IGridListOptions): IGridListOptions {
            let result = dgUtils.ObjectHelperService.mergeDeep({
                type: 'grid',
                templateUrl: '/digmo/src/actions/list-query/list-query.html',
                displayValue: 'Grid',
                actionColumnEnabled: true,
                useExternalSorting: false,
                useGridScroll: true
            }, options);
            return result;
        }

        public static getBadgeOptions(options?: IBadgeListOptions): IBadgeListOptions {
            return {
                type: 'badge',
                data: {},
                badgeDefn: null
            }
        }

        /*public static getRowListOptions(options?: cl.IDgRowListOptions): cl.IDgRowListOptions {
            return {
                type: 'row-list',
                rowTemplateUrl: null,
                data: null
            }
        }

        public static getHierarchyOptions(options?: cl.IDgHierarchyOptions): cl.IDgHierarchyOptions {
            return {
                type: 'hierarchy',
                data: null,
                filterOptions: null
            }
        }*/
    }

    angular.module('dg.lists')
        .service('listOptionsService', ListOptionsService);
}

